if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      SELECTORS = {
        pickupLocations: ".pickup-availability-locations",
        pickupPreview: "pickup-availability-preview",
        pickupLocationPreview: '.pickupPreviewLocations',
        pickupStatus: '.pickup-status-block'
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const pickupLocations = document.querySelector(this.SELECTORS.pickupLocations);
        if (pickupLocations) pickupLocations.remove();

        const pickupPreview = sectionInnerHTML.querySelector(this.SELECTORS.pickupPreview)
        if (!pickupPreview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = pickupPreview.outerHTML;
        this.setAttribute('available', '');

        const locationPreview = document.querySelector(this.SELECTORS.pickupLocationPreview)
        if(!locationPreview) return

        locationPreview.innerHTML = ''
        locationPreview.appendChild(sectionInnerHTML.querySelector(this.SELECTORS.pickupLocations));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        const colorClassesToApplyToStatus = this.dataset.statusColorScheme?.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          const locationsOnList = document.querySelectorAll(`${this.SELECTORS.pickupLocations} li`)
          if(locationsOnList) {
            locationsOnList.forEach((l) => {
              l.classList.add(colorClass);
            })
          }
        });

        colorClassesToApplyToStatus?.forEach((colorClass) => {
          const statuses = document.querySelectorAll(this.SELECTORS.pickupStatus)
          if(statuses) {
            statuses.forEach((status) => {
              status.classList.add(colorClass);
            })
          }
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector(this.SELECTORS.pickupLocations).show(evt.target);
          });
      }
    }
  );
}
